import React, { Component } from "react";
import { Form, Modal } from "antd";
import FormCreate from "../../../../../../components/FormCreate/index";
import styles from "./index.less";

const { FormTitle } = FormCreate;

@Form.create()
class EditNameModal extends Component {
  constructor(props) {
    super(props);
    const { data } = props;
    const { templateName } = data;
    this.state = {
      tempTemplateName: templateName // 用来临时记录初始名字的，因为第一次进来从getFieldsValue里取不到值
    };
  }

  handleOk = () => {
    const { onOk, form, data } = this.props;
    const { id, templateType } = data;
    const { validateFields } = form;
    validateFields((err, { templateName = "" }) => {
      if (!err && onOk) {
        onOk({ id, templateName, templateType });
      }
    });
  };

  // 输入框的值更改时的回调
  handleValueChange = e => {
    this.setState({
      tempTemplateName: e.target?.value
    });
  };

  render() {
    const { title, form, data, onCancel } = this.props;
    const { tempTemplateName } = this.state;
    const { getFieldsValue } = form;
    const { templateName } = data;

    const templateNameValue = getFieldsValue().templateName || "";

    const normNameProps = {
      form,
      value: templateName,
      label: "指标模板名称",
      keyName: "templateName",
      maxLength: 100,
      onChange: this.handleValueChange,
      suffix: `${tempTemplateName?.length || 0}/100`
    };

    return (
      <Modal
        title={title}
        centered
        visible
        onOk={this.handleOk}
        onCancel={onCancel}
        okButtonProps={{
          disabled:
            !templateNameValue.trim().length ||
            templateNameValue.trim().length > 100
        }}
        wrapClassName={styles.reNameModal}
      >
        <FormCreate labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <FormTitle {...normNameProps} />
        </FormCreate>
      </Modal>
    );
  }
}

export default EditNameModal;
